import { Button as AntButton } from 'antd';


export const Button = ({ className, onClick, ...props }: any) => {
    return <AntButton className={className} onClick={onClick} {...props} />;
};

